import React, { useState, useEffect, useRef } from "react";
import queryString from "query-string";
import { CSSTransition } from "react-transition-group";
import { Form, Progress, Alert } from "reactstrap";
import { useLocalization, WithLocalize } from "../../containers/I18nProvider";
import { WithCaptcha } from '../../containers/captcha';
import logo from './img/betel-logo.png';

const LoginForm = ({ api, location, TurnstileComponent, ...props }) => {
  const nodeRef = useRef(null);
  const { translate } = useLocalization();
  const [onLogin, setOnLogin] = useState(false);
  const [showForm, setShowForm] = useState(false);
  const [error, setError] = useState({
    open: false,
    message: "",
  });
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");

  const parameters = queryString.parse(location.search);

  useEffect(() => {
    setShowForm(true)
  }, []);

  const onSubmit = async (ev) => {
    ev.preventDefault();
    setOnLogin(true)
    setError({
      open: false,
      message: "",
    })

    api.userPassLogin(
      {
        username,
        password,
        cp_convert: parameters.cp_convert
      },
      parameters
    )
      .then((response) => {
        setOnLogin(false)
        window.location = parameters.redirect_uri + "?" + queryString.stringify(response);
      })
      .catch((error) => {
        const _translate = translate(error.errorCode);
        let message = translate("RequestLoginErrorMessage")
        if (_translate) {
          message = _translate;
        } else if (error.details) {
          message = error.details;
        }
        setOnLogin(false)
        setError({ open: true, message })
      });
  }

  return (
    <CSSTransition
      in={showForm}
      timeout={300}
      classNames="formshow"
      nodeRef={nodeRef}
      unmountOnExit
    >
      <div className="betel-oauth-body">
        <Form onSubmit={(event) => onSubmit(event)} className="login-betel">
          <div className="wrapper-betel fadeInDown" ref={nodeRef}>
            <div id="snackbar"></div>
            <div id="formContent-betel">
              <div className="menu1-betel">
                <div className="betel-logo fadeIn first">
                  <img src={logo} alt="Betel TV" />
                </div>
                <h2 className="fadeIn first betel-title">{translate("ClientAuthentication")}</h2>

                <div className="fadeIn second">
                  <div className="input-with-icon-betel">
                    <span className="input-icon-betel">👤</span>
                    <input
                      disabled={onLogin}
                      onChange={e => setUsername(e.target.value)}
                      required={true}
                      tabIndex={1}
                      type="text"
                      autoCorrect="off"
                      autoCapitalize="none"
                      name="login"
                      id="login-betel"
                      placeholder={translate("PlaceholderUserName")}
                    />
                  </div>
                </div>

                <div className="fadeIn third">
                  <div className="input-with-icon-betel">
                    <span className="input-icon-betel">🔒</span>
                    <input
                      required={true}
                      disabled={onLogin}
                      onChange={e => setPassword(e.target.value)}
                      tabIndex={2}
                      type="password"
                      autoCorrect="off"
                      autoCapitalize="none"
                      id="password-betel"
                      name="password"
                      placeholder={translate("PlaceholderPassword")}
                    />
                  </div>
                </div>

                <div className="fadeIn fourth">
                  <TurnstileComponent setTurnstileSuccess={props.setTurnstileSuccess} />
                </div>

                <div className="buttons-betel fadeIn fourth">
                  {!onLogin ? (
                    <button
                      type="submit"
                      id="entrar-betel"
                      disabled={!props.turnstileSuccess}
                    >
                      <span className="entrar-text-betel">
                        {translate("ButtonEnter")}
                      </span>
                    </button>
                  ) : (
                    <Progress animated color="info" value={100} style={{ height: '48px' }} />
                  )}
                </div>

                {/* Uncomment when password reset URL is confirmed
                <div className="text-center fadeIn fifth">
                  <p className='forgotPass-betel'>
                    <a href="https://silicomlan.ispcube.online/dgo/recoverpassword?company=573#/" target="_blank" rel="noopener noreferrer">
                      {translate('ForgotPassword')}
                    </a>
                  </p>
                </div>
                */}

                <div className="messages-container">
                  <Alert
                    color="danger"
                    id="error-message"
                    isOpen={error.open}
                    toggle={() => setError({ open: false })}
                  >
                    {error.message}
                  </Alert>
                </div>
              </div>
            </div>
          </div>
        </Form>
      </div>
    </CSSTransition>
  );
}

export default WithCaptcha(WithLocalize(LoginForm), { useInsideForm: true, style: { marginTop: '2rem' } });
